import { Box, Button, Grid, Typography } from '@mui/material'
import React from 'react'
import HalfSizeBanner from '../../components/Banners/HalfSizeBanner'
import { Link } from 'react-router-dom'
import Accordions from '../../components/Accordions/Accordions'
import SmallCards from '../../components/Cards/SmallCards'
import BigCard from '../../components/Cards/BigCard'
import { useTranslation } from '../../hook/Translation'
import TextBtnSection from '../../components/Section/TextBtnSection'
import Cards from '../../components/Cards/Cards'

export default function Exomind() {
    const { t } = useTranslation();

    const accodirons = [
        {
            title: t('what'),
            content: t('exomind.what')
        },
        {
            title: t('how'),
            content: t('exomind.how')
        },
        {
            title: t('benefits'),
            content: t('exomind.benefits')
        },
        {
            title: t('zone'),
            content: t('exomind.zone')
        },
        {
            title: t('when_expected_results'),
            content: t('exomind.when_expected_result')
        },
        {
            title: t('results'),
            content: t('exomind.results')
        },
    ];
    const data2 = [
        {
            imageUrl: '/images/fractional/hourglass-end.svg',
            title: t('time'),
            description: t('exomind.time'),
        },
        {
            imageUrl: '/images/fractional/headache.svg',
            title: t('discomfort'),
            description: t('exomind.discomfort'),
        },
        {
            imageUrl: '/images/fractional/duration.svg',
            title: t('downtime'),
            description: t('exomind.downtime'),
        },
        {
            imageUrl: '/images/fractional/facial-treatment.svg',
            title: t('sessions'),
            description: t('exomind.sessions'),
        }
    ]

    const data = [
        {
            header: t('homepage.mindCard1'),
            imageUrl: `${process.env.REACT_APP_API_URL}/images/2025/12/EXOMIN_1.png`
            // buttonText: 'LEARN MORE',
            // buttonUrl: '/'
        },
        {
            header: t('homepage.mindCard2'),
            imageUrl: `${process.env.REACT_APP_API_URL}/images/2025/12/EXOMIND_2.png`
            // buttonText: 'LEARN MORE',
            // buttonUrl: '/'
        },
        {
            header: t('homepage.mindCard3'),
            imageUrl: `${process.env.REACT_APP_API_URL}/images/2025/12/EXOMIND_3.png`
            // buttonText: 'LEARN MORE',
            // buttonUrl: '/'
        },
    ]

    return (

        <Box>
            <Box>
                <HalfSizeBanner height={{ md: '460px', xs: 'atuo' }}>
                    <Box height={{ md: '100%', xs: '500px' }} bgcolor={'text.secondary'} position={'relative'}>
                        {/* <Grid container alignItems={'center'} className='generalContainer' height={'100%'} marginX={'auto'} zIndex={10} position={'relative'}>
                            <Grid size={{ md: 7, xs: 12 }}>
                                <Grid container spacing={4} paddingY={{ md: 'unset', xs: '1.12rem' }}>
                                    <Grid size={{ md: 9, xs: 12 }}>
                                        <Typography variant="h3" className='wColor' fontFamily={'DanmarkURW'} fontSize={{ md: '2.875rem', xs: '1.875rem' }}>{t('exomind.mainTitle')}</Typography>
                                    </Grid>
                                    <Grid size={{ md: 11, xs: 12 }}>
                                        <Typography variant="body1" className='wColor' fontSize={{ md: '1.125rem', xs: '1rem' }}>
                                            {t('exomind.mainDesc')}
                                        </Typography>
                                    </Grid>
                                    <Grid size={10}>
                                        <Grid container spacing={4}>
                                            <Grid size={6}>
                                                <Button className='borderRadiusFlat borderWidth2 buttonPaddingY10 noShadow placeBorder whiteBorderColor' fullWidth>
                                                    {t('book_now')}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>

                        </Grid> */}
                        <Box sx={{ position: { md: 'absolute', xs: 'relative' }, top: 0, right: 0, width: { md: '80%', xs: '100%' }, height: '100%', backgroundImage: `url("${process.env.REACT_APP_SITE_URL}/images/2025/12/Exomind.png")`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPositionX: { md: 'unset', xs: '100%' } }}>
                        </Box>
                    </Box>
                </HalfSizeBanner>
            </Box>

            <Box className="generalContainer" marginX={'auto'} marginTop={{ md: '80px', xs: '50px' }}>
                <TextBtnSection
                    titleSize={{ md: 8, xs: 12 }}
                    data={{
                        type: t('mind_therapy'),
                        title: t('exomind.mainTitle'),
                        description: t('exomind.mainDesc'),
                        bookUrl: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e EXOMIND")}`,
                        learn: "",
                        // price: `${t('price_session')} €350\n${t('price_package')} 4 ${t('price_seanc')}: €950\nPako promocinale: €950 4 seanca`
                        price: `${t('price_session')} €290\n${t('exomind.promo')}`
                    }}
                />
            </Box>

            <Box className="generalContainer" marginX={'auto'} marginTop={{ md: '120px', xs: '50px' }}>
                <Typography variant="h1" sx={{ whiteSpace: 'pre-wrap' }} fontWeight={'regular'} textAlign={'center'} color="text.secondary" fontSize={{ md: '30px', xs: '1.175rem' }}>{t('exomind.desc')}</Typography>
            </Box>

            <Box marginTop={{ md: '104px', xs: '50px' }}>
                <Box component={'img'} src='/images/fractional/Path 134.svg' width={1} sx={{ objectFit: 'cover' }} />
            </Box>

            <Box>
                <Box marginTop={{ md: '84px', xs: '50px' }} className='generalContainer' marginX={'auto'}>
                    <SmallCards data={data2} />
                </Box>
            </Box>

            <Box sx={{ width: { md: '65%', xs: '90%' }, marginX: 'auto', marginTop: { md: '80px', xs: '50px' } }}>
                <Box sx={{ height: { md: 550, xs: 'auto' } }}>
                    <BigCard
                        data={{
                            book: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e EXOMIND")}`,
                            type: t('exomind.tech'),
                            // learn: '/',
                            title: t('exomind.techTitle'),
                            size: { md: 6.5, xs: 12 },
                            btnContainer: { md: 10, xs: 12 },
                            imageSize: { md: 5.5, xs: 12 },
                            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/03/exomind-card.png`,
                            flexDirection: { md: 'row-reverse', xs: 'column-reverse' },
                            description: t('exomind.techDesc')
                        }}
                        extraStyle={{
                            background: 'linear-gradient(90deg,rgba(30, 53, 61, 1) 0%, rgba(30, 53, 61, 1) 35%, rgba(30, 53, 61, 1) 50%, rgba(30, 53, 61, 1) 100%)'
                        }}
                        bgColor={'unset'}
                    />
                </Box>
            </Box>

            <Box width={{ md: '60%', xs: '90%' }} marginX={'auto'} border={'solid 1px #DBDAD9'} mt={{ md: '128px', xs: '50px' }}>
                <Grid container bgcolor={'#FFFFFF'} padding={{ md: 8, xs: 6 }} position={'relative'}>
                    <Box component={'img'} src='/images/Layer 2.svg' position={'absolute'} top={-32} right={20} height={80} width={107} />
                    <Grid size={12}>
                        <Grid container spacing={4}>
                            <Grid size={{ md: 11, xs: 12 }}>
                                <Typography variant="h3" color="text.secondary" fontSize={{ md: '30px', xs: '1.125rem' }} fontWeight={'600'}>{t('exomind.drText')}</Typography>
                            </Grid>
                            <Grid size={12}>
                                <Typography variant="body1" color="text.secondary" fontSize={'16px'} fontWeight={'600'}>Dr. Yael Halaas, MD.</Typography>
                                <Typography variant="body1" color="text.secondary">New York, NY</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>

            <Box height={{ md: '825px', xs: 'auto' }} marginTop={{ md: '156px', xs: '50px' }} position={'relative'} flexDirection={{ md: 'unset', xs: 'column-reverse' }} display={{ md: 'flex', xs: 'flex' }} gap={{ md: 0, xs: '20px' }}>
                <Box position={{ md: 'absolute', xs: 'relative' }} top={0} left={0} width={1} height={{ md: 1, xs: '200px' }} bgcolor={'#cde4f2'}>
                    <Box component={'img'} src={`${process.env.REACT_APP_API_URL}/images/Mask Group 40.png`} height={1} width={1} sx={{ objectFit: 'cover', opacity: { md: 1, xs: 1 } }} />
                </Box>
                <Box sx={{ width: { md: '582px', xs: '90%' } }} paddingTop={{ md: '80px', xs: '50px' }} mx={'auto'} position={'relative'} zIndex={2}>
                    <Typography variant="h1" color="text.secondary" fontFamily={'DanmarkURW'} fontWeight={'bold'} fontSize={{ md: '46px', xs: '2rem' }} textAlign={'center'}>Unlock Your Mind with EXOMIND</Typography>
                    <Typography variant="body1" color="text.secondary" fontSize={'1rem'} textAlign={'center'}>{t('exomind.banner_tech')}</Typography>
                </Box>
            </Box>
            <Box paddingTop={{ md: '119px', xs: '50px' }} paddingBottom={{ md: '134px', xs: '50px' }}>
                <Grid container gap={{ md: '80px', xs: '30px' }} className="generalContainer" sx={{ marginX: 'auto' }} marginTop={{ md: '100px', xs: '50px' }}>
                    <Grid size={12}>
                        <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={'1.125rem'}>{t('additional_information')}</Typography>
                    </Grid>
                    <Grid size={12}>
                        <Accordions data={accodirons} />
                    </Grid>
                </Grid>

            </Box>

            <Grid container sx={{ width: { md: '60%', xs: '90%' }, marginX: 'auto' }}>
                <Grid size={12}>
                    <Cards data={data} headerAlign={'center'} />
                </Grid>
            </Grid>

            <Grid container sx={{ width: { md: '60%', xs: '90%' }, marginX: 'auto', mt: { md: '102px', xs: '50px' } }} gap={'20px'}>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={'1.125rem'}>{t('exomind.it_includes')}</Typography>
                </Grid>
                <Grid>
                    <Typography variant="h1" color="text.secondary" fontWeight={'regular'} fontSize={{ md: '30px', xs: '2rem' }} textAlign={'center'}>{t('exomind.it_includes_desc')}</Typography>
                </Grid>
            </Grid>

            <Box mt={{ md: '65px', xs: '50px' }}>
                <HalfSizeBanner height={{ md: '520px', xs: 'auto' }}>
                    <Box>
                        <HalfSizeBanner height={{ md: '520px', xs: 'auto' }}>
                            <BigCard
                                data={{
                                    book: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e EXOMIND")}`,
                                    // type: 'Program',
                                    // learn: '/',
                                    title: t('exomind.training'),
                                    imageUrl: `${process.env.REACT_APP_API_URL}/images/applicator-img__ScaleWidthWzEwMjRd.png`,
                                    // flexDirection: { md: 'row-reverse', xs: 'row' },
                                    description: t('exomind.trainingDesc')
                                }}
                                extraStyle={{
                                    bgcolor: 'RGBA(33, 51, 59, 1)'
                                }}
                                extraImageStyle={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    img: {
                                        height: { md: '70%', xs: '100%' },
                                        width: { md: 'auto', xs: '100%' }
                                    }
                                }}
                            />
                        </HalfSizeBanner>
                    </Box>
                </HalfSizeBanner>
            </Box>
            <Grid container sx={{ width: { md: '60%', xs: '90%' }, marginX: 'auto', mt: { md: '87', xs: '50px' } }} gap={'20px'} mb={{ md: '165px', xs: '50px' }}>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={'1.125rem'}>{t('exomind.effects')}</Typography>
                </Grid>
                <Grid>
                    <Typography variant="h1" color="text.secondary" fontWeight={'regular'} fontSize={{ md: '30px', xs: '2rem' }} textAlign={'center'}>{t('exomind.effectsDesc')}</Typography>
                </Grid>
            </Grid>

            {/* <Box paddingTop={{ md: '120px', xs: '50px' }} paddingBottom={{ md: '129px', xs: '50px' }}>
                <Grid container spacing={8} justifyContent={'center'}>
                    <Grid size={12}><Typography variant="body1" color="text.secondary" textAlign={'center'} fontWeight={'bold'}>Quick Links</Typography></Grid>
                    <Grid size={{ md: 8, xs: 9 }}>
                        <Grid container spacing={{ md: 'unset', xs: 4 }}>
                            <Grid size={{ md: 4, xs: 12 }}>
                                <Box component={'ul'} padding={0} margin={0}>
                                    <Box component={'li'} marginBottom={'10px'}><Typography variant="body1" color="text.secondary" sx={{ textDecoration: 'underline' }} component={Link}>Skincare Products</Typography></Box>
                                    <Box component={'li'} marginBottom={'10px'}><Typography variant="body1" color="text.secondary" sx={{ textDecoration: 'underline' }} component={Link}>Daily Skincare Regime Formulas</Typography></Box>
                                    <Box component={'li'} marginBottom={'10px'}><Typography variant="body1" color="text.secondary" sx={{ textDecoration: 'underline' }} component={Link}>Cruelty-Free Serums</Typography></Box>
                                    <Box component={'li'} marginBottom={'10px'}><Typography variant="body1" color="text.secondary" sx={{ textDecoration: 'underline' }} component={Link}>Moisturisers With Spf</Typography></Box>
                                </Box>
                            </Grid>
                            <Grid size={{ md: 4, xs: 12 }}>
                                <Box component={'ul'} padding={0} margin={0}>
                                    <Box component={'li'} marginBottom={'10px'}><Typography variant="body1" color="text.secondary" sx={{ textDecoration: 'underline' }} component={Link}>Anti—Aging Skincare Products</Typography></Box>
                                    <Box component={'li'} marginBottom={'10px'}><Typography variant="body1" color="text.secondary" sx={{ textDecoration: 'underline' }} component={Link}>Pigmentation Skincare</Typography></Box>
                                    <Box component={'li'} marginBottom={'10px'}><Typography variant="body1" color="text.secondary" sx={{ textDecoration: 'underline' }} component={Link}>In-Clinic Treamerpts</Typography></Box>
                                    <Box component={'li'} marginBottom={'10px'}><Typography variant="body1" color="text.secondary" sx={{ textDecoration: 'underline' }} component={Link}>Beauty Advice</Typography></Box>
                                </Box>
                            </Grid>
                            <Grid size={{ md: 4, xs: 12 }}>
                                <Box component={'ul'} padding={0} margin={0}>
                                    <Box component={'li'} marginBottom={'10px'}><Typography variant="body1" color="text.secondary" sx={{ textDecoration: 'underline' }} component={Link}>Skin Peels At Home</Typography></Box>
                                    <Box component={'li'} marginBottom={'10px'}><Typography variant="body1" color="text.secondary" sx={{ textDecoration: 'underline' }} component={Link}>Nutritional Supplements For Health Skin</Typography></Box>
                                    <Box component={'li'} marginBottom={'10px'}><Typography variant="body1" color="text.secondary" sx={{ textDecoration: 'underline' }} component={Link}>Formulas For Breakouts And Oily Skin</Typography></Box>
                                    <Box component={'li'} marginBottom={'10px'}><Typography variant="body1" color="text.secondary" sx={{ textDecoration: 'underline' }} component={Link}>Dry And Sensitive Skin Product</Typography></Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box> */}

        </Box>

    )
}
